/*
 * jQuery css bezier animation support -- Jonah Fox
 * version 0.0.1
 * Released under the MIT license.
 */


(function($) {

    $( document ).ready(function() {
        //accordion hide/show fix
        var $accordion = $('#accordion');
        $accordion.on('show.bs.collapse','.collapse', function() {
            $accordion.find('.collapse.in').collapse('hide');
        }).on('shown.bs.collapse', function() {
            logUserEvent( 'tab_click' );
        });

        //modals show/hide
        $(".modal-trigger-stations").click(function(e){
            e.preventDefault();
            $("#modal-info-stations").modal('show');
            logUserEvent( 'about_stations_click' );
        });

        $(".modal-trigger-about-data").click(function(e){
            e.preventDefault();
            $("#modal-info-about-data").modal('show');
            logUserEvent( 'about_this_data_click' );
        });

        $("#modal-info-stations .modal-header button.close").click(function(e){
                $('.modal-trigger-stations').focus();
            }
        );

        $("#modal-info-about-data .modal-header button.close").click(function(e){
                $('.modal-trigger-about-data').focus();
            }
        );

        var $stationModal = $("#modal-info-stations"),
            $stationModalClose = $(".modal-header button");

        $stationModal.on("shown.bs.modal", function() {
            document.activeElement.blur();
            $stationModalClose.focus();
        });

        var $infDataModal = $("#modal-info-about-data"),
            $infDataModalClose = $(".modal-header button");

        $infDataModal.on("shown.bs.modal", function() {
            document.activeElement.blur();
            $infDataModalClose.focus();
        });

    });

})(jQuery); // End of use strict
